import LoadingScreen from '@/components/common/LoadingScreen'
import { usePermission } from '@/hooks/permissions'
import { ReactElement, useEffect } from 'react'
import toast from 'react-hot-toast'
import { Navigate, useLocation } from 'react-router-dom'

interface RequireNotViewOnlyProps {
  children: ReactElement
  redirectTo: string
}

/**
 * Component that prevents ViewOnly users from accessing certain routes
 */
const RequireNotViewOnly = ({
  redirectTo,
  children,
}: RequireNotViewOnlyProps) => {
  const { pathname: from } = useLocation()
  const { isViewOnly, isAccessControlLoading } = usePermission()

  useEffect(() => {
    // Wait for access-control to finish loading before judging: on a fresh
    // SSO login the permission list is briefly empty, which would otherwise
    // read as ViewOnly and fire a false toast.
    if (!isAccessControlLoading && isViewOnly) {
      toast.error('ViewOnly users cannot access admin pages!')
    }
  }, [isViewOnly, isAccessControlLoading])

  if (isAccessControlLoading) {
    return <LoadingScreen />
  }

  if (isViewOnly) {
    return <Navigate replace to={redirectTo} state={{ from }} />
  }

  return children
}

export default RequireNotViewOnly
